export default "__VITE_ASSET__Bg7yrYW7__"